export enum SortFieldsHospital {
  Date = 'date',
  Status = 'status',
  ServiceType = 'service_type'
}
